import { render, staticRenderFns } from "./produce_data.vue?vue&type=template&id=8c5c6bec&"
import script from "./produce_data.vue?vue&type=script&lang=js&"
export * from "./produce_data.vue?vue&type=script&lang=js&"
import style0 from "./produce_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports